import React from 'react';
import { motion } from 'framer-motion';
import { painPoints } from '../data/painPoints';
export function PainPoints() {
  return <section aria-label="Problemi" className="border-y border-grape/10 bg-white/70" data-id="element-137" data-mp="2lmsqcmz6p8ku">
      <div className="mx-auto max-w-4xl px-5 pb-12 pt-10" style={{
      paddingBottom: '8px',
      paddingTop: "8px"
    }} data-id="element-138" data-mp="26xmt34jwpsfl">
        <h2 className="text-center font-display text-[25px] font-black text-plum sm:text-4xl" data-id="element-139" data-mp="2bvy1rbygtww8">
          ❓ Ti riconosci in una di queste situazioni?
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-center text-base leading-relaxed text-plum/70" data-id="element-140" data-mp="21zus7l1aavz9">
          Ami i K-Drama e il K-Pop, vuoi capire cosa dicono davvero, ma ogni volta che provi a
          imparare il coreano ti perdi tra i simboli, le app e le liste di vocaboli casuali che non
          portano da nessuna parte.
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-center text-lg font-bold text-grape" data-id="element-141" data-mp="3ie4hqih9iqro">
          Non è mancanza di talento. Non è mancanza di impegno. È la mancanza di un sistema visivo.
        </p>

        <div className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-142" data-mp="1yyu5r7f9jr9k">
          {painPoints.map((p, i) => <motion.div key={p.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i % 2 * 0.08,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex gap-3 rounded-xl border border-grape/15 bg-cream p-5" style={{
          paddingTop: "15px",
          paddingBottom: "15px"
        }} data-id="element-143" data-mp="1u0so8qxhk007" data-mpi={i}>
              <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-lilac-soft text-sm" aria-hidden="true" data-id="element-144" data-mp="1b52l30dtgxkq">
                {p.emoji}
              </span>
              <div data-id="element-145" data-mp="1k5im83737smf">
                <h3 className="text-sm font-bold text-plum" data-id="element-146" data-mp="30hnyhs3a1c1w">{p.title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-plum/65" data-id="element-147" data-mp="30jqucsr41zej">{p.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-148" data-mp="1t5oiwxoow7xb">
          <p className="font-display text-2xl font-bold text-plum sm:text-3xl" data-id="element-149" data-mp="1t4vjyivz2mpq">
            ✨ Se hai risposto SÌ a una di queste situazioni, abbiamo la soluzione.
          </p>
          <p className="mt-3 text-lg font-semibold text-blush-deep" data-id="element-150" data-mp="2274sx4ble810">
            Il giorno 60 può suonare completamente diverso.
          </p>
        </div>
      </div>
    </section>;
}